import { appModulesToRequiredUserRoles } from "@jugl-web/domain-resources/common/consts";
import { PageNavParams } from "@web-src/modules/navigation/types";
import { ModulePagesConfig } from "@web-src/modules/navigation/types/ModulePagesConfigs";
import { lazy } from "react";
import { WorkspaceFeaturesPage } from "./WorkspaceFeaturesPage/WorkspaceFeaturesPage";

const WorkspaceSubscriptionPage = lazy(
  () => import("./WorkspaceSubscriptionPage")
);
const WorkspaceNoSubscriptionPage = lazy(
  () => import("./WorkspaceNoSubscriptionPage")
);
const WorkspaceSettingsPage = lazy(() => import("./WorkspaceSettingsPage"));
const CPanelPage = lazy(() => import("./CPanelPage"));
const SelectSubscriptionPage = lazy(() => import("./SelectSubscriptionPage"));

export type WorkspacePagesNavigationParams = {
  workspaceSubscription: PageNavParams;
  workspaceNoSubscription: PageNavParams;
  workspaceSelectSubscription: PageNavParams;
  workspaceSettings: PageNavParams;
  workspaceMembers: PageNavParams;
  workspaceFeatures: PageNavParams;
};

export const workspacePagesNavigationConfig: ModulePagesConfig<WorkspacePagesNavigationParams> =
  {
    workspaceSubscription: {
      element: <WorkspaceSubscriptionPage />,
      path: "workspace/subscription",
      isPrivate: true,
      requiredUserRoles: appModulesToRequiredUserRoles.workspace,
      isActiveSubscriptionOptional: true,
    },
    workspaceNoSubscription: {
      element: <WorkspaceNoSubscriptionPage />,
      path: "no-subscription",
      isPrivate: true,
      isActiveSubscriptionOptional: true,
    },
    workspaceSelectSubscription: {
      element: <SelectSubscriptionPage />,
      path: "workspace/subscription/manage",
      isPrivate: true,
      requiredUserRoles: appModulesToRequiredUserRoles.workspace,
      isActiveSubscriptionOptional: true,
    },
    workspaceSettings: {
      element: <WorkspaceSettingsPage />,
      path: "workspace/settings",
      isPrivate: true,
      requiredUserRoles: appModulesToRequiredUserRoles.workspace,
    },
    workspaceMembers: {
      element: <CPanelPage />,
      path: "workspace/members",
      isPrivate: true,
      requiredUserRoles: appModulesToRequiredUserRoles.workspace,
    },
    workspaceFeatures: {
      element: <WorkspaceFeaturesPage />,
      path: "workspace/features",
      isPrivate: true,
      requiredUserRoles: appModulesToRequiredUserRoles.workspace,
    },
  };
